import { render, staticRenderFns } from "./FieldsEditor.vue?vue&type=template&id=6bb4fa64"
import script from "./FieldsEditor.vue?vue&type=script&lang=js"
export * from "./FieldsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports